var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcPin = function SvgIcPin(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 21 29",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6501 10.15V2.9H18.1001C18.8976 2.9 19.5501 2.2475 19.5501 1.45C19.5501 0.6525 18.8976 0 18.1001 0H3.60007C2.80257 0 2.15007 0.6525 2.15007 1.45C2.15007 2.2475 2.80257 2.9 3.60007 2.9H5.05007V10.15C5.05007 12.557 3.10707 14.5 0.700073 14.5V17.4H9.35657V27.55L10.8066 29L12.2566 27.55V17.4H21.0001V14.5C18.5931 14.5 16.6501 12.557 16.6501 10.15Z",
    fill: "#2E63FB"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-pin.cb31d08a.svg";
export { ForwardRef as ReactComponent };